import { Component, ElementRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { NavigationEnd, Router, RouterLink, RouterLinkActive } from '@angular/router';
import { NgOptimizedImage } from '@angular/common';
import { SessionService } from '../../core/services/session-service';
import { User } from '../../core/models/user';
import { filter } from 'rxjs';
import { NotificationBell } from '../notification-bell/notification-bell';

@Component({
  selector: 'app-sidebar',
  imports: [RouterLink, RouterLinkActive, NgOptimizedImage, NotificationBell],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './sidebar.html',
})
export class Sidebar {
  @ViewChild('dropdown') dropdown!: ElementRef;
  protected user: User | null;
  protected isPfpDropdownOpen = false;

  constructor(
    private readonly sessionService: SessionService,
    private readonly router: Router,
  ) {
    this.user = sessionService.getCurrentUser();
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe({
        next: () => (this.user = this.sessionService.getCurrentUser()),
      });
  }

  get username() {
    return this.user?.name || 'Admin';
  }

  get isPfpDropdownVisible() {
    return this.isPfpDropdownOpen;
  }

  toggleDropdown() {
    this.isPfpDropdownOpen = !this.isPfpDropdownOpen;
  }

  closeDropdown() {
    this.isPfpDropdownOpen = false;
  }

  logout() {
    this.sessionService.logout();
    this.router.navigate(['/login']).then();
  }
}
